// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"382":"76807936","453":"6a6f984d"}[chunkId] + ".chunk.js";
};